<template>
	<v-combobox no-filter flat :rounded="rounded" light :hide-details="true" outlined solo ref="searchBox"
		placeholder="Search a City, Town or Area" :value="value" :allow-overflow="false" :items="suggestions"
		:loading="loading" :search-input.sync="searchQuery" item-text="formatted_address" item-value="formatted_address"
		v-bind="$attrs" @focus="clearResults" @input="handleTyping" @blur="handleBlur" @change="handleSelect"
		style="width: 100%;" :class="['custom-combobox', searchClasses, justifyCenter ? 'justify-center-input' : '']">
		<template v-slot:item="{ item }">
			<v-list style="max-height: 300px; overflow-y: auto; width: 100%;">
				<v-list-item @click="selectItem(item)">
					<v-list-item-title v-text="item.formatted_address" />
				</v-list-item>
				<v-list-item v-if="!suggestions.length && searchQuery">
					<v-list-item-title>
						Start typing to choose an address
					</v-list-item-title>
				</v-list-item>
			</v-list>
		</template>

		<template v-slot:selection="{ item }">
			<span :class="justifyCenter ? 'd-flex justify-center text-center align-center' : ''" style="width: 100%;"
				v-if="item && item.formatted_address">
				{{ item.formatted_address }}
			</span>
		</template>

		<template v-slot:append>
			<v-tooltip color="#0b4073" nudge-top="5" top>
				<template v-slot:activator="{ on, attrs }">
					<v-btn color="#0b4073" icon v-bind="attrs" @click.stop="getGeolocation" v-on="on">
						<v-icon size="24">near_me</v-icon>
					</v-btn>
				</template>
				<span style="font-size: 16px;">
					Use my current location
				</span>
			</v-tooltip>
		</template>
	</v-combobox>
</template>

<script>
// import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";
import { availableCountries } from "@/settings/currencies";
import { locationSetter, } from "@/utils/utils";

export default {
	name: "BrebAutocompleteLocation",
	props: {
		value: null,
		rounded: {
			type: Boolean,
			default: false,
		},
		limit: {
			type: Number,
			default: 10,
		},
		justifyCenter: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			searchQuery: null,
			suggestions: [],
			loading: false,
			availableCountries,
		};
	},
	computed: {
		cellphone() {
			return this.$vuetify.breakpoint.xs;
		},
		mobile() {
			return this.$vuetify.breakpoint.mobile;
		},
		searchClasses() {
			return {
				search: this.rounded,
				"search-mobile": this.mobile,
				"align-center": true,
			};
		},
	},
	watch: {
		searchQuery() {
			this.handleTyping();
		},
	},
	methods: {
		clearResults() {
			this.suggestions = [];
			this.searchQuery = null;
			// this.$emit("input", null);
			if (this.value?.formatted_address) {
				this.$emit("placechanged", null);
			}
		},
		// async handleInput(choice) {
		// 	if (!choice) {
		// 		this.$emit("input", null);
		// 		return;
		// 	}
		// 	this.$emit("input", choice.formattedAddress || choice.name || choice.description);
		// 	this.$emit("placechanged", choice);
		// },
		handleTyping: debounce(function () {
			if (this.searchQuery?.length > 5) {
				this.performSearch();
			} else {
				this.suggestions = [];
			}
		}, 400),
		async performSearch() {
			this.loading = true;
			try {
				const res = await this.$store.dispatch("api/geocode/autocomplete", {
					query: this.searchQuery,
					countries: this.availableCountries.join(","),
					limit: this.limit,
				});
				this.suggestions = res?.data?.results || [];
			} catch (err) {
				const { status, message } = err.response?.data || {};
				this.$toasted.error(`Fail to search location by keyword: ${status ? "Error Code: " + status + "," : ""} ${message || err}`);
			}
			this.loading = false;
		},
		async getGeolocation() {
			try {
				const coordinates = await this.$getLocation();
				const res = await this.$store.dispatch("api/geocode/reverse", {
					lat: coordinates.lat,
					lng: coordinates.lng,
					countries: this.availableCountries.join(","),
					limit: this.limit,
				});

				const results = res?.data?.results;
				if (!Array.isArray(results) || results.length === 0) {
					this.$toasted.show("Cannot locate the current position, please input manually to saerch a city");
					return;
				}
				const placeResult = results.find(item => item.metadata?.type === "place") || results[0];

				this.handleSelect(placeResult)
			} catch (err) {
				if (err.response) {
					const { message, status } = err.response.data;
					this.$toasted.error(`Fail to search location by coordinate: error code ${status}, ${message}`);
				} else {
					this.$toasted.error(`Fail to search location by coordinate: ${err}`);
				}
			}
			this.$emit('disableLoading');
		},
		selectItem(item) {
			if (!item || !item.formatted_address) return;
			this.$emit("placechanged", locationSetter(item));
			this.handleBlur();
		},
		handleSelect(val) {
			this.selectItem(val)
			this.handleBlur();
		},
		handleBlur() {
			this.$refs.searchBox.blur();
			this.$emit("blur");
		},
	},
	created() {

	},
};
</script>

<style scoped>
.v-input>>>input {
	font-size: 1.1rem;
}

.justify-center-input>>>input {
	text-align: center;
}

.custom-combobox>>>.v-input__slot {
	padding-left: 12px;
	padding-right: 12px;
}
</style>
